/**
 * Pure helpers for the product-creation page (#277): what the form must hold before it can
 * be sent.
 */
import type { CreateBody, Market } from '../../services/adminProducts.service';

export const DESCRIPTION_MIN = 20;
export const DESCRIPTION_MAX = 2000;
export const MARKETS: readonly Market[] = ['MX', 'US', 'CA'];

export interface ProductForm {
  fundsProductId: string;
  markets: Market[];
  description: string;
  riskLevel: string;
}

/** The first thing wrong with the form, in plain words, or null when it can be sent. */
export function productProblem(form: ProductForm): string | null {
  if (!form.fundsProductId) return 'Choose the funds vehicle.';
  if (form.markets.length === 0) return 'Choose at least one market.';
  const length = form.description.trim().length;
  // Static texts: the Spanish dictionary is keyed by the exact English sentence.
  if (length < DESCRIPTION_MIN) return 'The description needs at least 20 characters.';
  if (length > DESCRIPTION_MAX) return 'The description is at most 2000 characters.';
  return null;
}

export function toCreateBody(form: ProductForm, mfaCode: string): CreateBody {
  const risk = Number.parseInt(form.riskLevel, 10);
  return {
    funds_product_id: form.fundsProductId,
    supported_markets: form.markets,
    funding_route: 'private_fund',
    description: form.description.trim(),
    risk_level: Number.isNaN(risk) ? null : risk,
    mfa_code: mfaCode,
  };
}

export function toggleMarket(markets: Market[], market: Market): Market[] {
  return markets.includes(market) ? markets.filter((m) => m !== market) : [...markets, market];
}
